import React, { Suspense, useRef } from "react";
import { BrowserRouter } from "react-router-dom";

import Nav from "./components/layout/Nav/";
import Footer from "./components/layout/Footer/";
import {
  ModalProvider
} from 'react-simple-hook-modal';
import Routes from "./Routes";

function App() {
    return (
			<BrowserRouter basename = { process.env.REACT_APP_BASENAME } >
				<ModalProvider>
					<Nav />
					<main id = "main" >
						<Suspense fallback = { <div > </div>}>
							<Routes />
						</Suspense>
					</main >
					<Footer />
				</ModalProvider>
			</BrowserRouter>
		);
}
export default App;